"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/program/types");
function startProgram() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_START_PROGRAM) return true;
  return state;
}
var _default = exports["default"] = startProgram;